import { render, staticRenderFns } from "./UpdateGeoserverModal.vue?vue&type=template&id=3b97334c&scoped=true&"
import script from "./UpdateGeoserverModal.vue?vue&type=script&lang=js&"
export * from "./UpdateGeoserverModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateGeoserverModal.vue?vue&type=style&index=0&id=3b97334c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b97334c",
  null
  
)

export default component.exports